import store from "./store";

export default {
  modules: {
    store: store
  }
};
